import { formatStr, generateSpan, SyntaxTreeRecognize, TokenUtil } from '@patsnap/query-translator'
import { useLocale } from '@pharmsnap/shared/composition'
import { defineComponent, onMounted, onUnmounted, ref } from '@vue/composition-api'
import cn from './locales/cn.json'
import en from './locales/en.json'
import jp from './locales/jp.json'

export const EditQueryContainer = defineComponent({
  name: 'EditQueryContainer',
  i18n: {
    messages: {
      cn,
      en,
      jp,
    },
  },
  props: {},
  setup(props, { emit }) {
    // query-translator 仅支持 cn/en,日文界面下降级取英文
    const { fieldLang } = useLocale()
    const queryContainer = ref()
    let isCnTyping = false
    const ex = '(keyword:(PD-1 OR PD-L1)) AND (inhibitors OR modulators) NOT (NSCLC OR "Breast cancer")'
    const formattedStr = formatStr(ex)
    const tokens = TokenUtil.getInstance().getSyntaxTree(formattedStr)
    console.log('tokens', tokens)
    const queryItem = SyntaxTreeRecognize.getInstance().trans2QueryItem(tokens)
    console.log('queryItem', queryItem)
    /**
     * tokens生成span
     */
    function handleGenerateSpan(str?: string) {
      console.log('handleGenerateSpan', str)
      const syntaxTree = generateSpan({
        dom: queryContainer.value,
        str,
        lang: fieldLang.value,
      })
      emit('input', syntaxTree)
    }

    /**
     * 输入的回调
     * @param e
     * @returns
     */
    function onInput(e: KeyboardEvent) {
      const { code } = e
      if (code === 'Enter') return
      if (isCnTyping) return
      const syntaxTree = generateSpan({
        dom: queryContainer.value,
        lang: fieldLang.value,
        syncCursorPos: true,
      })

      emit('input', syntaxTree)
    }

    /**
     * 支持中文输入
     */
    function onCompositionstart() {
      isCnTyping = true
    }
    function onCompositionend() {
      isCnTyping = false
      const syntaxTree = generateSpan({
        dom: queryContainer.value,
        lang: fieldLang.value,
        syncCursorPos: true,
      })
      emit('input', syntaxTree)
    }

    function bindEvents() {
      queryContainer.value.addEventListener('input', onInput)
      queryContainer.value.addEventListener('compositionstart', onCompositionstart)
      queryContainer.value.addEventListener('compositionend', onCompositionend)
    }

    function disposeEvents() {
      if (!queryContainer.value) return
      queryContainer.value.removeEventListener('input', onInput)
      queryContainer.value.removeEventListener('compositionstart', onCompositionstart)
      queryContainer.value.removeEventListener('compositionend', onCompositionend)
    }

    onMounted(bindEvents)
    onUnmounted(disposeEvents)

    return { queryContainer, handleGenerateSpan }
  },
  methods: {
    setQueryStr(str: string) {
      if (!str) {
        this.handleGenerateSpan('')
      } else {
        this.handleGenerateSpan(str)
      }
    },
  },
  render() {
    return (
      <div
        ref="queryContainer"
        class="outline-none"
        contenteditable
        placeholder={this.$tc('BEditQueryDialog.placeholder')}
        onFocusin={() => {
          this.$emit('focusin')
        }}
        onFocusout={() => {
          this.$emit('focusout')
        }}
      ></div>
    )
  },
})
